/* eslint-disable max-len */
import React from 'react';

import styles from './index.module.css';

const defaultHeading = 'Похоже, что-то пошло не так';
const defaultText = 'Попробуйте еще раз';

export default ({
  heading = defaultHeading,
  text = defaultText
}) => (
  <div className={styles.wrapper}>
    <svg width="99" height="100" viewBox="0 0 99 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M63.5553 9.07021C45.1503 2.21814 23.7249 8.03928 11.2912 23.2142C-1.11269 38.3475 -2.79893 60.2376 7.3583 77.0162C17.4659 93.7214 37.3737 102.457 56.5227 98.6872C78.2159 94.4157 93.9031 74.8423 94.0667 52.8852C93.9229 33.4898 81.7868 15.8593 63.5553 9.07021Z" fill="#EFF3FE" />
      <path d="M67.0315 88.3125C49.7177 94.4709 30.0432 89.1054 18.2147 75.078C6.16306 60.7917 4.58591 39.751 14.252 23.7831C23.824 7.9685 42.814 -0.391043 60.9461 3.31864C81.4191 7.50783 96.1886 25.8633 96.3423 46.6625C96.2035 65.1291 84.5337 82.0848 67.0315 88.3125ZM68.3061 2.84756C49.9062 -4.00452 28.481 1.81662 16.0474 16.9915C3.6436 32.1248 1.95734 54.015 12.1095 70.7936C22.222 87.4988 42.1296 96.2342 61.2784 92.4645C82.9714 88.1935 98.6584 68.6191 98.8221 46.6625C98.6783 27.2672 86.5423 9.63665 68.3061 2.84756Z" fill="#1E54B7" />
      <path d="M40.75 37.125C40.75 40.2316 38.2316 42.75 35.125 42.75C32.0184 42.75 29.5 40.2316 29.5 37.125C29.5 34.0184 32.0184 31.5 35.125 31.5C38.2316 31.5 40.75 34.0184 40.75 37.125Z" fill="#1E54B7" stroke="#EFF3FE" strokeWidth="3" />
      <path d="M73.9335 37.0918C73.9335 40.18 71.43 42.6835 68.3418 42.6835C65.2535 42.6835 62.75 40.18 62.75 37.0918C62.75 34.0035 65.2535 31.5 68.3418 31.5C71.43 31.5 73.9335 34.0035 73.9335 37.0918Z" fill="#1E54B7" stroke="#EFF3FE" strokeWidth="3" />
      <path d="M34.7291 66.1768L33.9479 59.9255L68.7715 55.5737L69.5527 61.8251L34.7291 66.1768Z" fill="#1E54B7" stroke="#EFF3FE" strokeWidth="3.2" />
    </svg>
    <h4 className={styles.heading}>
      {heading}
    </h4>
    <p className={styles.text}>{text}</p>
  </div>
);
